import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" viewBox="7 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M21.9,8.1c-1.6,0.4-3.2,1.8-3.7,3.3L18,11.9L18,38L18,64l0.2,0.5c0.4,1.4,1.8,2.7,3.4,3.2c0.2,0.1,0.4,0.1,0.5,0.2
		c0.1,0,5,0.1,11.7,0.1h11.5V38V8L33.9,8C22.9,8,22.4,8,21.9,8.1z M35.6,15.7c0.2,0.1,0.6,0.8,2.4,4c1.2,2.1,2.5,4.5,3,5.4
		c0.5,0.9,1.2,2.2,1.7,2.9s0.8,1.5,0.9,1.6c0.2,0.3,0.2,0.3,0.2,0.7c0,0.5-0.1,0.7-0.5,0.9c-0.2,0.1-0.2,0.1-8.3,0.2
		c-4.5,0-8.2,0-8.4,0c-0.1,0-0.3-0.1-0.5-0.3c-0.3-0.3-0.4-0.6-0.3-1c0.1-0.3,8-14.1,8.2-14.3C34.4,15.4,35.1,15.4,35.6,15.7z
		 M37.3,41c2.9,0.2,4.2,0.6,4.7,1.5l0.2,0.3l0,5.6v5.6L42,54.3c-0.2,0.4-0.6,0.6-1,0.7l-0.4,0.1v0.4c0,0.4,0,0.4-0.2,0.5
		c-0.2,0.1-0.3,0.1-1.2,0.1c-1,0-1.1,0-1.2-0.1c-0.2-0.1-0.2-0.2-0.2-0.6v-0.4h-3h-3v0.4c0,0.3,0,0.4-0.2,0.6
		c-0.2,0.2-0.2,0.2-1.2,0.2c-1.3,0-1.4,0-1.4-0.7l0-0.4L28.6,55c-0.3-0.1-0.5-0.1-0.7-0.4c-0.2-0.2-0.3-0.4-0.4-0.6
		c-0.1-0.4-0.1-11,0-11.3c0.1-0.4,0.5-0.8,1-1c0.8-0.4,2.6-0.7,5.5-0.8C34.5,40.8,36.2,40.9,37.3,41z"
          fill={colourFill}
        />
        <path
          d="M33.4,41.9c-0.1,0-0.1,0.2-0.1,0.5c0,0.4,0,0.4,0.1,0.5c0.1,0,0.6,0.1,1.4,0.1c0.7,0,1.3,0,1.4-0.1
		c0.1-0.1,0.1-0.1,0.1-0.5c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.5-0.1-1.4-0.1C34,41.8,33.4,41.8,33.4,41.9z"
          fill={colourFill}
        />
        <path
          d="M29,44c-0.1,0.1-0.1,0.4-0.1,2.8c0,2,0,2.7,0.1,2.8c0.1,0.1,1.4,0.1,5.9,0.1c5.6,0,5.8,0,5.8-0.1c0-0.1,0.1-1.1,0.1-2.8
		c0-2.3,0-2.7-0.1-2.8c-0.1-0.1-0.7-0.1-5.8-0.1C29.7,43.9,29,43.9,29,44z"
          fill={colourFill}
        />
        <path
          d="M29,51c-0.1,0.1-0.1,0.3-0.1,0.8c0,0.9,0,0.9,1.2,0.9c0.8,0,1,0,1.1-0.1c0.2-0.1,0.2-0.2,0.2-0.6c0-0.3,0-0.4-0.1-0.5
		c-0.1-0.1-1.7-0.6-2-0.6C29.1,50.9,29,50.9,29,51z"
          fill={colourFill}
        />
        <path
          d="M39.2,51.1c-0.9,0.3-1,0.3-1,0.9c0,0.3,0,0.4,0.2,0.5c0.2,0.2,0.2,0.2,1.1,0.2c1.3,0,1.3,0,1.3-0.9
		C40.7,50.7,40.6,50.7,39.2,51.1z"
          fill={colourFill}
        />
        <path
          d="M52.9,38v30h0.9c0.5,0,0.9,0,0.9-0.1c0,0,0.2-0.1,0.4-0.1c1.3-0.3,2.8-1.5,3.4-2.6C59,64.2,59,66.7,59,38V12l-0.2-0.5
		c-0.4-1.3-1.3-2.3-2.7-3C55.3,8.1,54.8,8,53.7,8h-0.8V38z"
          fill={colourFill}
        />
      </g>
    </svg>
  );
};

export default ServiceIcon;
